import { createSelector } from '@reduxjs/toolkit';

const selectLeadSlice = (state) => state.lead;

// === Dashboard ===
export const selectDashboardLeads = createSelector([selectLeadSlice], (lead) => lead.newDashLead);
export const selectLeadCounter = createSelector([selectLeadSlice], (lead) => lead.counter);
export const selectTaskTableData = createSelector([selectLeadSlice], (lead) => lead.taskTableData);
export const selectAllReminders = createSelector([selectLeadSlice], (lead) => lead.allReminders);
export const selectTaskCounter = createSelector([selectLeadSlice], (lead) => lead.taskCounter);
export const selectDashNewContact = createSelector([selectLeadSlice], (lead) => lead.dashNewContact);
export const selectDashboardTaskPageFilter = createSelector([selectLeadSlice], (lead) => lead.dashboardTaskPageFilter);
export const selectIsTasksCompleted = createSelector([selectLeadSlice], (lead) => lead.isTasksCompleted);

// === Status-specific tables ===
export const selectNewStatusLead = createSelector([selectLeadSlice], (lead) => lead.newStatusLead);
export const selectConsultantAttendLead = createSelector([selectLeadSlice], (lead) => lead.consultantAttendStatusLead);
export const selectConsultantClinCheckLead = createSelector([selectLeadSlice], (lead) => lead.consultantClinCheckStatusLead);
export const selectAttendedChecklistsLead = createSelector([selectLeadSlice], (lead) => lead.attendedChecklistsStatusLead);
export const selectConsultantBookedLead = createSelector([selectLeadSlice], (lead) => lead.consultantBookedStatusLead);
export const selectFailedToAttendLead = createSelector([selectLeadSlice], (lead) => lead.failedToAttendStatusLead);
export const selectClosedLead = createSelector([selectLeadSlice], (lead) => lead.closedStatusLead);
export const selectTreatmentStartedLead = createSelector([selectLeadSlice], (lead) => lead.treatmentStartedStatusLead);

// === Lead Detail ===
export const selectLeadDetail = createSelector([selectLeadSlice], (lead) => lead.leadDetail);
export const selectTableRowLead = createSelector([selectLeadSlice], (lead) => lead.tableRowLead);
export const selectFollowUpLead = createSelector([selectLeadSlice], (lead) => lead.followUpLead);
export const selectFollowLead = createSelector([selectLeadSlice], (lead) => lead.followLead);
export const selectLeadNotes = createSelector([selectLeadSlice], (lead) => lead.leadNotes);
export const selectLeadNotesArr = createSelector([selectLeadSlice], (lead) => lead.leadNotesArr);
export const selectNewLeadDetail = createSelector([selectLeadSlice], (lead) => lead.newLeadDetail);
export const selectCreateLead = createSelector([selectLeadSlice], (lead) => lead.createLead);
export const selectArchivedLead = createSelector([selectLeadSlice], (lead) => lead.archivedLead);
export const selectLeadFlowReminder = createSelector([selectLeadSlice], (lead) => lead.leadFlowReminder);
export const selectTaskFlowCounter = createSelector([selectLeadSlice], (lead) => lead.taskFlowCounter);
export const selectIsAppointmentBooked = createSelector([selectLeadSlice], (lead) => lead.isAppointmentBooked);

// === Search ===
export const selectSearchedLead = createSelector([selectLeadSlice], (lead) => lead.searchedLead);
export const selectUniversalSearch = createSelector([selectLeadSlice], (lead) => lead.universalSearchResults);

// === Loading/Error ===
export const selectLeadIsLoading = createSelector([selectLeadSlice], (lead) => lead.isLoading);
export const selectLoadingForLead = createSelector([selectLeadSlice], (lead) => lead.loadingForLead);
export const selectLeadError = createSelector([selectLeadSlice], (lead) => lead.error);

// === Table/Contact filters ===
export const selectDashContact = createSelector([selectLeadSlice], (lead) => lead.dashContact);
export const selectNewContact = createSelector([selectLeadSlice], (lead) => lead.newContact);
export const selectAttendContact = createSelector([selectLeadSlice], (lead) => lead.attendContact);

// === Misc ===
export const selectAttendance = createSelector([selectLeadSlice], (lead) => lead.attendance);
export const selectBookingAttendance = createSelector([selectLeadSlice], (lead) => lead.BookingAttendance);
export const selectMarkAsComplete = createSelector([selectLeadSlice], (lead) => lead.markAsComplete);
export const selectContactLead = createSelector([selectLeadSlice], (lead) => lead.contactLead);
export const selectFollowUpTableMoved = createSelector([selectLeadSlice], (lead) => lead.followUpTableMoved);
export const selectMultiLead = createSelector([selectLeadSlice], (lead) => lead.multiLead);
export const selectAction = createSelector([selectLeadSlice], (lead) => lead.action);

// === Composed selectors (derived data) ===
export const selectDashboardLabelCounter = createSelector([selectDashNewContact], (dashNewContact) => dashNewContact?.labelCounter);
